module.exports = {"id":"210950","name":"Pablo De Blasis","rating":"76","photo":"./data/images/photos/1/210950.png","club":{"name":"FSV Mayence 05","logo":"./data/images/clubs/FSVMayence05.png"},"positions":["MG","MD","MOC"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/PabloDeBlasis0.json
// module id = 3342
// module chunks = 0